import React, {useState} from 'react';

import styles from './stlyes/docs-header.module.css';

import Button from '../../common-women/Button';
import InputFilter from '../../common-women/InputFilter';
import ModalWrapper from '../../modal-women/ModalWrapper';

import {ReactComponent as Plus} from '../../../assets/docs-women/plus.svg';
import {ReactComponent as Upload} from '../../../assets/docs-women/upload.svg';

export default function DocsHeader({ depth, name, handleChange }) {
    const [openUploadModal, setOpenUploadModal] = useState(false);
    const [openCreateModal, setOpenCreateModal] = useState(false);

    const showCreateBtn = depth === 0 || depth === 1;

    const toggleUploadModal = () => {
        setOpenUploadModal(!openUploadModal);
    };

    const toggleCreateModal = () => {
        setOpenCreateModal(!openCreateModal);
    };

    return (
        <div className={styles.wrapper}>
            <InputFilter
                type={showCreateBtn ? 'short-docs-filter' : 'long-docs-filter'}
                placeholder='검색'
                name='name'
                value={name}
                handleChange={handleChange}
            />
            {showCreateBtn
                ? <Button
                    Icon={Plus}
                    text='카테고리 추가'
                    width='160px'
                    height='50px'
                    padding='12px'
                    backgroundColor='#EFEFEF'
                    borderRadius='10px'
                    fontSize='15px'
                    fontWeight='600'
                    onClick={toggleCreateModal}
                />
                : null
            }
            <Button
                Icon={Upload}
                text='파일 업로드'
                width='160px'
                height='50px'
                padding='12px'
                backgroundColor='#825DFC'
                borderRadius='10px'
                fontSize='15px'
                fontWeight='600'
                textColor='#FFF'
                onClick={toggleUploadModal}
            />

            {openUploadModal &&
                <ModalWrapper 
                    type='upload'
                    handleClose={toggleUploadModal}
                />
            }

            {openCreateModal &&
                <ModalWrapper 
                    type='create'
                    handleClose={toggleCreateModal}
                />
            }
        </div>
    );
}
